export const FAQs = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_293_24377)">
      <path
        d="M14 9.33333V14H9.33333C7.60958 14 6.10458 13.0579 5.29667 11.6643C5.74525 11.6608 6.18217 11.6112 6.6045 11.5197C7.24675 12.3194 8.23025 12.8333 9.33333 12.8333H12.8333V9.33333C12.8333 8.23025 12.3194 7.24675 11.5197 6.6045C11.6107 6.18217 11.6608 5.74525 11.6643 5.29667C13.0579 6.10458 14 7.60958 14 9.33333ZM10.5 5.25C10.5 2.35492 8.14508 0 5.25 0C2.35492 0 0 2.35492 0 5.25V10.5H5.25C8.14508 10.5 10.5 8.14508 10.5 5.25ZM1.16667 5.25C1.16667 2.99892 2.99833 1.16667 5.25 1.16667C7.50167 1.16667 9.33333 2.99892 9.33333 5.25C9.33333 7.50108 7.50167 9.33333 5.25 9.33333H1.16667V5.25ZM5.83333 6.12792C5.83333 5.94592 5.985 5.677 6.09408 5.61692C6.74975 5.25467 7.10267 4.51325 6.97258 3.77125C6.84833 3.06425 6.26792 2.48442 5.56267 2.36133C5.04583 2.26742 4.52258 2.40858 4.12592 2.74225C3.72808 3.07592 3.50058 3.56475 3.50058 4.08333H4.66725C4.66725 3.91008 4.74308 3.74733 4.87608 3.63592C5.01025 3.52333 5.18292 3.47783 5.36142 3.50992C5.5895 3.54958 5.78433 3.74383 5.824 3.9725C5.87825 4.28225 5.70033 4.50158 5.53117 4.59433C5.03825 4.86558 4.66725 5.52475 4.66725 6.12733V6.41608H5.83392V6.12733L5.83333 6.12792ZM5.83333 7H4.66667V8.16667H5.83333V7Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_293_24377">
        <rect width="14" height="14" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
